import './App.css';
import { useEffect, useState } from 'react';
import './styles/style.css';
import './styles/login.css';
import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import Main from './components/Main';
import {STATE} from './classes/Enum';
import { loadStripe } from '@stripe/stripe-js';
import { USERSTATES } from './classes/Enum';

const stripePromise = loadStripe(process.env.REACT_APP_API_STRIPE_PUBLIC_KEY);

function App() {
  const [state, setState] = useState(STATE.OVERVIEW);
  const [userState, setUserState] = useState(USERSTATES.SIGN);
  const [cart, setCart] = useState([]);
  const [user, setUser] = useState(null);

  useEffect (() => {
    setUser(localStorage.getItem('email'));
  }, [state]);

  return (
    <div id='App'>
        <div className='scrolling-bg'></div>
        <HeaderComponent/>
        <Main state={state} setState={setState} cart={cart} setCart={setCart} stripePromise={stripePromise} user={user} userState={userState} setUserState={setUserState}/>
        {state === STATE.SUCCESS ? null: <FooterComponent cart={cart} setState={setState} user={user} setUserState={setUserState}/>}

    </div>
  );
}

export default App;